var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "PrimaryApplicant" } },
    [
      _vm.sectionButton.name == "SetAsPrimaryApplicant" &&
      _vm.sectionButton.visible !== false
        ? _c(
            "button",
            {
              staticClass: "btn btn-onlyBorder px-1 wsn select list-item px-3",
              attrs: { type: "button", tabindex: "0" },
              on: {
                click: function($event) {
                  return _vm.promptsetPrimaryApplicantSection(
                    _vm.sectionButton,
                    "setPrimary-applicant-modal"
                  )
                },
                keydown: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.promptsetPrimaryApplicantSection(
                      _vm.sectionButton,
                      "setPrimary-applicant-modal"
                    )
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar"
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.promptsetPrimaryApplicantSection(
                      _vm.sectionButton,
                      "setPrimary-applicant-modal"
                    )
                  }
                ]
              }
            },
            [
              _c("div", { staticClass: "float-left text-left d-block pl-1" }, [
                _vm._v(
                  "\n     " +
                    _vm._s(_vm.sectionButton.label || "Unknown label") +
                    "\n   "
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.sectionButton.name !== "SetAsPrimaryApplicant"
        ? _c(
            "button",
            {
              staticClass:
                "section-heading-button btn btn-outline-success px-1 wsn select list-item px-3",
              attrs: { type: "button", tabindex: "0" },
              on: {
                click: function($event) {
                  return _vm.promptAlterSection(
                    _vm.section,
                    "remove-applicant-modal",
                    _vm.sectionButton.name
                  )
                },
                keydown: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.promptAlterSection(
                      _vm.section,
                      "remove-applicant-modal",
                      _vm.sectionButton.name
                    )
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar"
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.promptAlterSection(
                      _vm.section,
                      "remove-applicant-modal",
                      _vm.sectionButton.name
                    )
                  }
                ]
              }
            },
            [
              _c("icon", {
                staticClass: "d-block mx-auto float-left",
                attrs: { name: _vm.iconName, scale: "1.1" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "float-left text-left d-block pl-1" }, [
                _vm._v(
                  "\n     " +
                    _vm._s(_vm.sectionButton.label || "Unknown label") +
                    "\n   "
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-tooltip",
        {
          attrs: {
            target: "PrimaryApplicant",
            triggers: "focus hover",
            placement: "bottom"
          }
        },
        [
          _vm._v(
            "\n   Co-applicant information must be completed to enable switching applicants\n   "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "b-modal",
            {
              ref: "setPrimary-applicant-modal",
              attrs: {
                "hide-header": "",
                "hide-footer": "",
                "hide-header-close": "",
                "no-enforce-focus": ""
              }
            },
            [
              _c(
                "Trapmodal",
                {
                  attrs: {
                    group: "remove-modal",
                    id: "applicant-setPrimary-modal-id"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "remove-confirmation-box applicant-remove-modal",
                      attrs: { id: "applicant-setPrimary-modal" }
                    },
                    [
                      _c("div", { staticClass: "remove-modal-message mb-3" }, [
                        _c("div", [_vm._v("Switch the primary applicant?")]),
                        _vm._v(" "),
                        _c("p", { staticClass: "subParagraph" }, [
                          _vm._v(
                            "This will swap the primary and co-applicant infromation. You can make changes until the quote is bound."
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "remove-modal-sep mt-1 mb-1" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "remove-btn-box" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass:
                                "mt-3 remove-btn-cancel longer-width-button",
                              attrs: { block: "" },
                              on: {
                                keydown: [
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.closeModalApplicant(
                                      "setPrimary-applicant-modal"
                                    )
                                  },
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "space",
                                        32,
                                        $event.key,
                                        [" ", "Spacebar"]
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.closeModalApplicant(
                                      "setPrimary-applicant-modal"
                                    )
                                  }
                                ],
                                click: function($event) {
                                  return _vm.closeModalApplicant(
                                    "setPrimary-applicant-modal"
                                  )
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass:
                                "mt-3 section-header-button  longer-width-button",
                              attrs: { block: "" },
                              on: {
                                keydown: [
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.setPrimaryApplicantSection(
                                      _vm.section,
                                      "setPrimary-applicant-modal"
                                    )
                                  },
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "space",
                                        32,
                                        $event.key,
                                        [" ", "Spacebar"]
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.setPrimaryApplicantSection(
                                      _vm.section,
                                      "setPrimary-applicant-modal"
                                    )
                                  }
                                ],
                                click: function($event) {
                                  return _vm.setPrimaryApplicantSection(
                                    _vm.section,
                                    "setPrimary-applicant-modal"
                                  )
                                }
                              }
                            },
                            [_vm._v("\n             Switch Applicants")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "b-modal",
            {
              ref: "remove-applicant-modal",
              attrs: {
                "hide-header": "",
                "hide-footer": "",
                "hide-header-close": "",
                "no-enforce-focus": ""
              }
            },
            [
              _c(
                "Trapmodal",
                {
                  attrs: {
                    group: "remove-modal",
                    id: "applicant-remove-modal-id"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "remove-confirmation-box applicant-remove-modal",
                      attrs: { id: "applicant-remove-modal" }
                    },
                    [
                      _c("div", { staticClass: "remove-modal-message mb-3" }, [
                        _c("div", [
                          _vm._v(
                            "Are you sure you want to remove this co-applicant?"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "remove-modal-sep mt-1 mb-1" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "remove-btn-box" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass:
                                "mt-3 remove-btn-cancel remove-cust-btn",
                              attrs: { block: "" },
                              on: {
                                keydown: [
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.closeModalApplicant(
                                      "remove-applicant-modal"
                                    )
                                  },
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "space",
                                        32,
                                        $event.key,
                                        [" ", "Spacebar"]
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.closeModalApplicant(
                                      "remove-applicant-modal"
                                    )
                                  }
                                ],
                                click: function($event) {
                                  return _vm.closeModalApplicant(
                                    "remove-applicant-modal"
                                  )
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass:
                                "mt-3 remove-btn-confirm remove-cust-btn",
                              attrs: { block: "" },
                              on: {
                                keydown: [
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.deleteApplicantSection(
                                      _vm.section,
                                      "remove-applicant-modal"
                                    )
                                  },
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "space",
                                        32,
                                        $event.key,
                                        [" ", "Spacebar"]
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    return _vm.deleteApplicantSection(
                                      _vm.section,
                                      "remove-applicant-modal"
                                    )
                                  }
                                ],
                                click: function($event) {
                                  return _vm.deleteApplicantSection(
                                    _vm.section,
                                    "remove-applicant-modal"
                                  )
                                }
                              }
                            },
                            [_vm._v("\n             Remove")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-500f83e9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-500f83e9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/widgets/SectionHeadingButton.vue
// module id = null
// module chunks = 